import Vue from 'vue'
import Vuetify from 'vuetify'
Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  theme: {
    themes: {
      light: {
        'primary': '#66C6BA',
        'primary-light': '#99F9EC',
        'primary-dark': '#30958A',
        'accent': '#FFB783',
        'accent-light': '#FFE9B3',
        'accent-dark': '#C98755',
        'base-bg': '#FAFAFA',
        'blue': '#7293CB',
        'navy-blue': '#196B8F',
        'dark-blue': '#303F48'
      }
    }
  }

})
/*
Vue.use(Vuetify, {
  theme: {
    'primary': '#66C6BA',
    'primary-light': '#99F9EC',
    'primary-dark': '#30958A',
    'accent': '#FFB783',
    'accent-light': '#FFE9B3',
    'accent-dark': '#C98755',
    'base-bg': '#FAFAFA',
    'blue': '#7293CB',
    'navy-blue': '#196B8F',
    'dark-blue': '#303F48'
  }
}) */
